module.exports = {
  APILOCALURL: "http://localhost:5062/api/",
  APISERVERURL: "https://smartaccountsapi.azurewebsites.net/api/",
  APIACTIVEURL: "https://smartaccountsapi.azurewebsites.net/api/",
  DEFAULTCOMPANYID: "CB8E7EF0-2DE8-471B-82BB-328E26679007",
  LOGIN: "auth/login",
  REGISTER: "auth/register",
  LOGOUT: "auth/logout",
  REFRESH: "auth/refresh",
  SENDRESETLINK: "auth/sendresetlink",
  RESETPASSWORD: "auth/resetpassword",
  SENDCONFIRMATIONLINK: "auth/sendconfirmationlink",

  SAASREGISTER: "company/saasregister",
  SAASACTIVATE: "company/UpdateTaxInformation",
  VERIFYCOMPANY: "auth/verifyemail",

  GETUSERSBYCOMPANY: "user/getbycompany",
  GETUSERSBYBRANCH: "user/getbybranch",
  CREATEUSER: "user",
  UPDATEUSER: "user",
  DELETEUSER: "user",
  GETUSERPROFILE: "user/getprofile",
  CHANGEPASSWORD: "user/changepassword",

  GETALLCOMPANIES: "company/getall",
  GETCOMPANIES: "company/get",
  GETCOMPANYBYID: "company/getbyid",
  GETCOMPANYBYUSER: "company/getbyuser",
  GETCOMPANYAGENTS: "company/agents",
  CREATECOMPANY: "company",
  REGISTERCOMPANY: "company/registercompany",
  UPDATECOMPANY: "company",
  DELETECOMPANY: "company",

  GETALLBRANCHES: "branch/getall",
  GETBRANCHES: "branch/get",
  GETBRANCHBYID: "branch/getbyid",
  GETBRANCHBYUSER: "branch/getbyuser",
  GETBRANCHBYCOMPANY: "branch/getbycompany",
  CREATEBRANCH: "branch",
  UPDATEBRANCH: "branch",
  DELETEBRANCH: "branch",

  GETALLACCOUNTTYPES: "accounttype/getall",
  GETACCOUNTTYPES: "accounttype/get",
  GETACCOUNTTYPEBYID: "accounttype/getbyid",
  CREATEACCOUNTTYPE: "accounttype",
  UPDATEACCOUNTTYPE: "accounttype",
  DELETEACCOUNTTYPE: "accounttype",

  GETALLACCOUNTS: "account/getall",
  GETALLACCOUNTBYINDUSTRY: "account/getaccountbyindustry",
  GETACCOUNTS: "account/get",
  GETACCOUNTBYID: "account/getbyid",
  CREATEACCOUNT: "account",
  UPDATEACCOUNT: "account",
  DELETEACCOUNT: "account",

  GETALLCUSTOMERSBYUSER: "customer/getallcustomersbyUser",
  GETCUSTOMERBYUSER: "customer/getcustomersbyUser",
  CREATECUSTOMER: "customer",
  UPDATECUSTOMER: "customer",
  DELETECUSTOMER: "customer",

  GETALLVENDORSBYUSER: "vendor/getallvendorsbyUser",
  GETVENDORBYUSER: "vendor/getvendorsbyUser",
  CREATEVENDOR: "vendor",
  UPDATEVENDOR: "vendor",
  DELETEVENDOR: "vendor",

  GETALLBANKACCOUNTSBYUSER: "bankaccount/getallbankaccountsbyUser",
  GETBANKACCOUNTBYUSER: "bankaccount/getbankaccountsbyUser",
  CREATEBANKACCOUNT: "bankaccount",
  UPDATEBANKACCOUNT: "bankaccount",
  DELETEBANKACCOUNT: "bankaccount",

  GETALLTAXRATESBYUSER: "taxrate/getalltaxratesbyUser",
  GETTAXRATEBYUSER: "taxrate/gettaxratesbyUser",
  CREATETAXRATE: "taxrate",
  UPDATETAXRATE: "taxrate",
  DELETETAXRATE: "taxrate",

  GETEXCHANGERATEBYUSER: "exchangerate/getexchangeratesbyUser",
  CREATEEXCHANGERATE: "exchangerate",
  UPDATEEXCHANGERATE: "exchangerate",
  DELETEEXCHANGERATE: "exchangerate",

  GETALLITEMSBYUSER: "item/getallitemsbyuser",
  GETITEMSBYUSER: "item/getitemsbyuser",
  GETITEMSBYACCOUNTTYPE: "item/getitemsbyaccounttype",
  CREATEITEM: "item",
  UPDATEITEM: "item",
  DELETEITEM: "item",

  GETACCOUNTITEMSBYUSER: "accountitem/getaccountitemsbyuser",
  CREATEACCOUNTITEM: "accountitem",
  UPDATEACCOUNTITEM: "accountitem",
  DELETEACCOUNTITEM: "accountitem",

  GETINVOICEBYID: "invoice/getbyid",
  GETINVOICEBYUSER: "invoice/getbyuser",
  CREATEINVOICE: "invoice",
  UPDATEINVOICE: "invoice",
  DELETEINVOICE: "invoice",
  INVOICESUMMARY: "invoice/getinvoicesummary",
  GETSERIALNUMBER: "invoice/serialnumber",
  GENERATEINVOICENUMBER: "invoice/generateinvoicenumber",

  SEARCHCUSTOMERS: "reports/customersearch",
  SEARCHVENDORS: "reports/vendorsearch",
  SEARCHEXPENSEITEMS: "reports/expenseitemsearch",
  SEARCHSALESITEMS: "reports/salesitemsearch",
  SEARCHPURCHASESITEMS: "reports/purchasesitemsearch",
  SEARCHINVOICENUMBER: "reports/invoicenumbersearch",
  CUSTOMERREPORT: "reports/customer-invoices",
  VENDORREPORT: "reports/vendor-invoices",
  EXPENSEREPORT: "reports/expense-invoices",
  SALESREPORT: "reports/sales-by-item",
  PURCHASESREPORT: "reports/purchases-by-item",
  INVOICEREPORT: "reports/invoices",
  PROFITLOSSREPORT: "reports/profit-loss",
  PROFITLOSSACCOUNTWISEREPORT: "reports/profit-loss-accountwise",
  JOURNALENTRIESREPORT: "reports/journal-entries",

  GETALLINDUSTRIES: "industry/getall",
  GETINDUSTRIES: "industry/get",
  CREATEINDUSTRY: "industry",
  UPDATEINDUSTRY: "industry",
  DELETEINDUSTRY: "industry",

  GETALLINDUSTRYACCOUNTS: "industryaccount/getall",
  GETINDUSTRYACCOUNTS: "industryaccount/get",
  GETINDUSTRYACCOUNTBYID: "industryaccount/getbyid",
  CREATEINDUSTRYACCOUNT: "industryaccount",
  UPDATEINDUSTRYACCOUNT: "industryaccount",
  DELETEINDUSTRYACCOUNT: "industryaccount",

  GETCHEQUEBYUSER: "cheque/getbyuser",
  CREATECHEQUE: "cheque",
  UPDATECHEQUE: "cheque",
  DELETECHEQUE: "cheque",
  CHEQUESUMMARY: "cheque/getchequecount",
};
